<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <h4 class="title ">My Files</h4>
          <table class="table is-striped is-narrow ">
            <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <!--<th>Downloads</th>-->
              <th>Uploaded On</th>
              <th>Download Link</th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="file in uploadedfiles" :id="file.randname">
              <td>{{ file.name }}</td>
              <td>{{ file.type }}</td>
              <!--<td><span :style="'margin-left:18%;'">{{ file.downloads }}</span></td>-->
              <td>{{ file.created_on }}</td>
              <td><a :href="'/file/'+file.randname"><i :style="'margin-left:18%;'"
                                                       class="fa fa-lg fa-cloud-download"></i> </a></td>
              <td>
                <button class="button is-danger is-outlined" :style="'font-size:.8rem;'" v-on:click="deleteFile(file.randname)"><i
                  class="fa fa-lg fa-trash"></i></button>
              </td>
              <td>
                <button class="button is-danger is-outlined" :style="'font-size:.8rem;'" v-on:click="navigateTo('/edit/'+file.randname)"><i
                  class="fa fa-lg fa-pencil"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        uploadedfiles: []
      }
    },
    methods: {
      deleteFile (id) {
        this.$http({
          url: '/api/v1/delete/' + id
        }).then((response) => {
          if (response.status === 200 && response.data.success === true) {
            document.getElementById(id).remove()
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      navigateTo (path) {
        this.$router.push(path)
      }
    },
    beforeCreate () {
      this.$http({
        url: '/api/v1/files',
        transformResponse: [(data) => {
          return JSON.parse(data.replace(/T00:00:00Z/g, ''))
        }]
      }).then((response) => {
        this.uploadedfiles.push(...response.data.files)
      }).catch((error) => {
        console.log(error)
      })
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// MyFiles.vue?3c111445